module.exports = __webpack_public_path__ + "static/media/drumheller-1.1ed7b16c.jpg";